import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  TableSortLabel,
  CircularProgress,
  Grid,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const styles = {
  link: {
    display: 'block',
  },
  title: {
    marginTop: 20,
  },
  tableRow: {
    textDecoration: 'none',
  },
  listItem: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItemText: {
    marginTop: 2,
    marginBottom: 2,
  },
};

const SimpleLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
}));

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy] || a[orderBy] === null) {
    return -1;
  }
  if (b[orderBy] > a[orderBy] || b[orderBy] === null) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

function escapeHTML(text) {
  // const map = {
  //   '&amp;': '&',
  //   '&lt;': '<',
  //   '&gt;': '>',
  //   '&quot;': '"',
  //   '&#039;': "'"
  // }
  // return text.replace(/[&<>"']/g, function(m) { return map[m]; });
  if (text) {
    return text.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  } else {
    return text;
  }
}

// class PermitteeTable extends React.Component {
export default function PermitteeTable(props) {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('NAME');

  console.log('props.data:');
  console.log(props.data);

  const createSortHandler = (field) => (event) => {
    console.log(`field: ${field}`);
    const orderByTemp = field;
    let orderTemp = 'asc';
    if (orderBy === field && order === 'asc') {
      orderTemp = 'desc';
    }
    setOrder(orderTemp);
    setOrderBy(orderByTemp);
  };

  // render() {
  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell>
            <Tooltip title='Sort' enterDelay={300}>
              <TableSortLabel
                active={orderBy === 'NAME'}
                direction={order}
                onClick={createSortHandler('NAME')}
              >
                Permittee
              </TableSortLabel>
            </Tooltip>
          </TableCell>
          <TableCell>
            <Tooltip title='Sort' enterDelay={300}>
              <TableSortLabel
                active={orderBy === 'AREA'}
                direction={order}
                onClick={createSortHandler('AREA')}
              >
                Regulatory Area
              </TableSortLabel>
            </Tooltip>
          </TableCell>
          <TableCell>
            <Tooltip title='Sort' enterDelay={300}>
              <TableSortLabel
                active={orderBy === 'caseNumbers'}
                direction={order}
                onClick={createSortHandler('caseNumbers')}
              >
                Case Numbers
              </TableSortLabel>
            </Tooltip>
          </TableCell>
          <TableCell>
            <Tooltip title='Sort' enterDelay={300}>
              <TableSortLabel
                active={orderBy === 'leadWells'}
                direction={order}
                onClick={createSortHandler('leadWells')}
              >
                Lead Wells
              </TableSortLabel>
            </Tooltip>
          </TableCell>
          <TableCell>
            <Tooltip title='Sort' enterDelay={300}>
              <TableSortLabel
                active={orderBy === 'VIOLATIONS'}
                direction={order}
                onClick={createSortHandler('VIOLATIONS')}
              >
                Provisions
              </TableSortLabel>
            </Tooltip>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.loading && (
          <TableRow>
            <TableCell colSpan='3'>
              <Grid container justify='center' align='center'>
                <Grid item>
                  <CircularProgress />
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        )}
        {stableSort(props.data, getSorting(order, orderBy)).map((row, i) => (
          <TableRow key={i} hover onClick={props.onClick(row)}>
            <TableCell>{row.NAME}</TableCell>
            <TableCell>{row.AREA}</TableCell>
            <TableCell>
              {row.caseNumbers.map((item, index) => (
                <div key={index}>{item.replace(/-/g, '\u2011')}</div>
              ))}
            </TableCell>
            <TableCell>
              {row.leadWells.map((item, index) => (
                <div key={index}>{item}</div>
              ))}
            </TableCell>
            <TableCell>{escapeHTML(row.VIOLATIONS)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
  // }
}
